import React from "react";
import "./AonLabel.component.scss";
import { LABEL_STYLE, LABEL_TYPE, LabelTypeMap } from "./consts";
var getClassName = function (style, type, inline, darkMode) {
    var className = "bc-".concat(LabelTypeMap.get(type));
    className += inline ? " inline" : "";
    className += darkMode ? " dark-mode" : "";
    switch (type) {
        case LABEL_TYPE.H3_EXPANSION:
        case LABEL_TYPE.H5_EXPANSION:
        case LABEL_TYPE.H4_EXPANSION:
            className += " expansion";
            break;
        case LABEL_TYPE.SMALL:
            className += " small";
            break;
        case LABEL_TYPE.LARGE:
            className += " large";
            break;
        case LABEL_TYPE.EXTRA_SMALL:
            className += " extra-small";
            break;
        case LABEL_TYPE.EXTRA_LARGE:
            className += " extra-large";
            break;
        default:
            break;
    }
    switch (style) {
        case LABEL_STYLE.REGULAR:
            className += " regular";
            break;
        case LABEL_STYLE.LINK:
            className += " link";
            break;
        case LABEL_STYLE.BOLD:
            className += " bold";
            break;
        case LABEL_STYLE.BOLD_LINK:
            className += " bold link";
            break;
        case LABEL_STYLE.ITALIC:
            className += " italic";
            break;
        case LABEL_STYLE.ITALIC_LINK:
            className += " italic link";
            break;
        case LABEL_STYLE.DEFAULT:
            className += " default";
            break;
        case LABEL_STYLE.OPEN:
            className += " open";
            break;
        case LABEL_STYLE.LIGHT:
            className += " light";
            break;
        case LABEL_STYLE.LIGHT_LINK:
            className += " light link";
            break;
        default:
            break;
    }
    return className;
};
var AonLabel = function (_a) {
    var type = _a.type, style = _a.style, children = _a.children, inline = _a.inline, darkMode = _a.darkMode;
    switch (type) {
        case LABEL_TYPE.H1:
            return (React.createElement("h1", { className: getClassName(style, type, inline, darkMode) }, children));
        case LABEL_TYPE.H2:
            return (React.createElement("h2", { className: getClassName(style, type, inline, darkMode) }, children));
        case LABEL_TYPE.H3:
        case LABEL_TYPE.H3_EXPANSION:
            return (React.createElement("h3", { className: getClassName(style, type, inline, darkMode) }, children));
        case LABEL_TYPE.H4:
        case LABEL_TYPE.H4_EXPANSION:
            return (React.createElement("h4", { className: getClassName(style, type, inline, darkMode) }, children));
        case LABEL_TYPE.H5:
        case LABEL_TYPE.H5_EXPANSION:
            return (React.createElement("h5", { className: getClassName(style, type, inline, darkMode) }, children));
        case LABEL_TYPE.H6:
            return (React.createElement("h6", { className: getClassName(style, type, inline, darkMode) }, children));
        case LABEL_TYPE.BODY:
        case LABEL_TYPE.SMALL:
        case LABEL_TYPE.EXTRA_SMALL:
        case LABEL_TYPE.LARGE:
        case LABEL_TYPE.EXTRA_LARGE:
            return (React.createElement("p", { className: getClassName(style, type, inline, darkMode) }, children));
        default:
            return React.createElement("p", null, children);
    }
};
export { AonLabel };
